import React from 'react';
import classNames from 'classnames';

import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const TAB_NAMES = {
  TITLE: 'title',
  CONTENT: 'content',
};

export default function AdvancedSearchTabs({
  activeTab,
  setActiveTab,
  titleCount,
  contentCount,
  isLoading,
}) {
  return (
    <div className="d-f fd-r AdvancedSearchTabs-parent">
      <button
        type="button"
        className={classNames('AdvancedSearchTabs-tab u-resetBtn py-8 px-24', {
          'border-midnight-80': activeTab === TAB_NAMES.TITLE,
          'border-midnight-20': activeTab !== TAB_NAMES.TITLE,
        })}
        onClick={() => setActiveTab(TAB_NAMES.TITLE)}
        onMouseDown={e => {
          // Prevents mouse click focus ring
          e.preventDefault();
        }}
      >
        <Text
          variant={
            activeTab === TAB_NAMES.TITLE
              ? TEXT_VARIANTS.BODY_BOLD
              : TEXT_VARIANTS.BODY
          }
        >
          {t('contents.advanced_search.tabs.title')}
        </Text>
        <span
          className={classNames('AdvancedSearchTabs-tab-circle ml-8', {
            'AdvancedSearchTabs-tab-circle--loading': isLoading,
            'AdvancedSearchTabs-tab-circle--active':
              activeTab === TAB_NAMES.TITLE,
          })}
        >
          {isLoading ? '' : Number(titleCount).toLocaleString()}
        </span>
      </button>
      <button
        type="button"
        className={classNames('AdvancedSearchTabs-tab u-resetBtn py-8 px-24', {
          'border-midnight-80': activeTab === TAB_NAMES.CONTENT,
          'border-midnight-20': activeTab !== TAB_NAMES.CONTENT,
        })}
        onClick={() => setActiveTab(TAB_NAMES.CONTENT)}
        onMouseDown={e => {
          // Prevents mouse click focus ring
          e.preventDefault();
        }}
      >
        <Text
          variant={
            activeTab === TAB_NAMES.CONTENT
              ? TEXT_VARIANTS.BODY_BOLD
              : TEXT_VARIANTS.BODY
          }
        >
          {t('contents.advanced_search.tabs.content')}
        </Text>
        <span
          className={classNames('AdvancedSearchTabs-tab-circle ml-8', {
            'AdvancedSearchTabs-tab-circle--loading': isLoading,
            'AdvancedSearchTabs-tab-circle--active':
              activeTab === TAB_NAMES.CONTENT,
          })}
        >
          {isLoading ? '' : Number(contentCount).toLocaleString()}
        </span>
      </button>
    </div>
  );
}
